export default __webpack_public_path__ + "static/media/phoneLogo.9cd037e2.png";